import React from "react";
import "./CarModel.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Car from "../Car/Car";

const carModel = props => (
  <Grid container style={{ textAlign: "left", marginTop: "5px" }}>
    <Grid item xs={12} className="CarModelTitleDiv">
      <div className="CarModelTitle">{props.name}</div>
    </Grid>

    {props.cars.map(car => (
      <Grid item xs={12} sm={3}>
        <Car
          modelName={car.modelo}
          version={car.nombre}
          price={"$" + car.precio}
          image={car.image}
          version2={car.version}
          motor={car.motor}
          tipo={car.tipo}
          color={car.color}
          year={car.year}
          gear={car.gear}
          chasis={car.chasis}
          car={car}
        />
      </Grid>
    ))}
  </Grid>
);

export default carModel;
